// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3409":"67c7eae1cb2e0a1a","3748":"37d8af8dc085c9e1","8324":"f168116d6ef898c9","9365":"ab79cfd529552e53"}[chunkId] + ".css";
};